"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.execute = execute;
const child_process_1 = require("child_process");
function makeSpawnOptions(options) {
    const spawnOptions = {
        shell: false,
        env: Object.assign({}, process.env),
    };
    if (options === null || options === void 0 ? void 0 : options.cwd) {
        spawnOptions.cwd = options.cwd;
    }
    if (options === null || options === void 0 ? void 0 : options.env) {
        spawnOptions.env = Object.assign(Object.assign({}, spawnOptions.env), options.env);
    }
    else {
        spawnOptions.env = Object.assign({}, spawnOptions.env);
    }
    // Before spawning an external process, we check if we need to
    // restore the system proxy configuration, which overrides the CLI internal proxy configuration.
    if (process.env.SNYK_SYSTEM_HTTP_PROXY !== undefined) {
        spawnOptions.env.HTTP_PROXY = process.env.SNYK_SYSTEM_HTTP_PROXY;
    }
    if (process.env.SNYK_SYSTEM_HTTPS_PROXY !== undefined) {
        spawnOptions.env.HTTPS_PROXY = process.env.SNYK_SYSTEM_HTTPS_PROXY;
    }
    if (process.env.SNYK_SYSTEM_NO_PROXY !== undefined) {
        spawnOptions.env.NO_PROXY = process.env.SNYK_SYSTEM_NO_PROXY;
    }
    return spawnOptions;
}
function execute(command, args, options) {
    const spawnOptions = makeSpawnOptions(options);
    return new Promise((resolve, reject) => {
        var _a, _b;
        let stdout = '';
        let stderr = '';
        const proc = (0, child_process_1.spawn)(command, args, spawnOptions);
        (_a = proc.stdout) === null || _a === void 0 ? void 0 : _a.on('data', (data) => {
            stdout = stdout + data;
        });
        (_b = proc.stderr) === null || _b === void 0 ? void 0 : _b.on('data', (data) => {
            stderr = stderr + data;
        });
        proc.on('close', (code) => {
            if (code !== 0) {
                return reject(stdout || stderr);
            }
            resolve(stdout || stderr);
        });
    });
}
//# sourceMappingURL=subprocess.js.map